//idem dialogo iibb pero con las cosas por periodo
import React, { useState, useEffect } from "react";
import IconButton from "@mui/material/IconButton";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import DeleteIcon from "@mui/icons-material/Delete";
import InputMask from "react-input-mask";
import CircularProgress from "@mui/material/CircularProgress";
import InputAdornment from "@mui/material/InputAdornment";
import {
    Box,
    Select,
    FormControl,
    MenuItem,
    Button,
    Typography,
    Container,
    Alert
} from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";

//CUSTOM IMPORTS
import { getData } from "../../../../../../../services/library";
import TableHead from "./TableHead";
import AvisoNoRegistraInscripciones from "./AvisoNoRegistraInscripciones"
import CustomBackdrop from "../../../../../../CustomBackdrop";
import { RowIIBB } from "../RowIIBB";

export default function InscripcionesExclusionesForm({
    inscrIIBB,
    setShowCargaProxPeriodo,
    showAlertProxCiclo,
    configConvenio,
    almacenarImpuesto,
    deshacerAlmacenar,
    handleInputChange,
    actualizandoLista,
    provincias,
    handleInputChangeProvincia
}) {

    const inputProps = {
        disableUnderline: true,
        sx: {
            paddingTop: 0,
            paddingBottom: 0,
            height: "32px",
        },
    };

    const inputsx = {
        ".MuiFilledInput-root": {
            paddingTop: 0,
            paddingBottom: 0,
            height: "32px",
        },
        ".MuiInputBase-input": {
            paddingTop: "6px",
            paddingBottom: "6px",
        },
    };

    const columnSizes = {
        provincia: 4,
        coeficienteUnificado: 1,
        percepcion: 2,
        exencion: 1,
        vtoExencion: 2,
        acciones: 1,
    }

    const isOptionDisabled=(provincia)=>{
        return inscrIIBB.some((item) => item.id_provincia === provincia.id)
    }

    // console.log("Es esto")
    // console.log(configConvenio)

    return (
        <div>
            <Container maxWidth="xl" sx={{ p: 2 }}>
                {Number(configConvenio?.max_inscripciones) > 0 ? (
                    <Grid container>
                        {inscrIIBB?.length > 0 ? (
                            <>
                                <CustomBackdrop open={actualizandoLista} text={"Cargando impuestos.."} />
                                <TableHead columnSizes={columnSizes} showExclusiones={true} showFin={false} showInicio={false} showCoeficienteUnificado={configConvenio?.evalua_coeficiente_cm05 == 1} />
                                <form style={{ width: "100%" }}>
                                    <Grid item xs={12}>
                                        {inscrIIBB &&
                                            inscrIIBB.map((field, index) => (
                                                <RowIIBB
                                                    key={field.tempId}
                                                    field={field}
                                                    index={index}
                                                    totalRows={inscrIIBB.length}
                                                    provincias={provincias}
                                                    configConvenio={configConvenio}
                                                    columnSizes={columnSizes}
                                                    inputsx={inputsx}
                                                    inputProps={inputProps}
                                                    handleInputChange={handleInputChange}
                                                    deshacerAlmacenar={deshacerAlmacenar}
                                                    almacenarImpuesto={almacenarImpuesto}
                                                    isOptionDisabled={isOptionDisabled}
                                                    handleInputChangeProvincia={handleInputChangeProvincia}
                                                />
                                            ))}
                                    </Grid>
                                </form>
                            </>
                        ) : (
                            <Grid
                                container
                                direction="column"
                                justifyContent="center"
                                alignItems="center"
                                sx={{ py: 8 }}
                            >
                                <Grid item>
                                    <CircularProgress
                                        size={56}
                                        thickness={4}
                                        color="primary"
                                    />
                                </Grid>
                                <Grid item sx={{ mt: 3 }}>
                                    <Typography
                                        variant="h6"
                                        component="div"
                                        sx={{
                                            fontWeight: 500,
                                            color: "text.secondary",
                                            letterSpacing: "0.5px"
                                        }}
                                    >
                                        Cargando impuestos...
                                    </Typography>
                                </Grid>
                            </Grid>
                        )}
                    </Grid>
                ) : (
                    <AvisoNoRegistraInscripciones />
                )
                }
            </Container>
        </div>
    )
}




/*  
const rowKey = field.tempId; // Usamos el identificador único garantizado
// return (
//     <>
//         <Grid
//             container
//             alignItems="center"
//             justifyContent="space-between"
//             p={1}
//             backgroundColor="#fff"
//             mt={1}
//             borderRadius={1}
//             direction="row"
//             key={rowKey} // <-- AQUÍ ESTÁ LA CLAVE PRINCIPAL DE REACT                                               
//         >
//             <Grid
//                 item
//                 xs={columnSizes.provincia}
//                 sx={{
//                     display: "flex",
//                     alignItems: "center",
//                 }}
//             >
//                 <LocationOnIcon color="primary" />
//                 {provincias && (
//                     <FormControl fullWidth>
//                         <Select
//                             disabled={!!field.id_provincia}
//                             variant="filled"
//                             size="small"
//                             value={field.id_provincia}
//                             // onChange={(e) => handleInputChange(index, e)}
//                             onChange={(e) => handleInputChange(rowKey, e)}
//                             name="id_provincia"
//                             sx={{
//                                 ...inputsx,
//                                 height: "32px",
//                                 "&:before": {
//                                     borderBottom: "none",
//                                 },
//                                 "&:hover:not(.Mui-disabled):before": {
//                                     borderBottom: "none",
//                                 },
//                                 "&:after": {
//                                     borderBottom: "none",
//                                 },
//                             }}
//                         >
//                             {provincias.map((provincia) => {
//                                 // const isDisabled = inscrIIBB.some(
//                                 //     (item) =>
//                                 //         item.id_provincia === provincia.id
//                                 // );

//                                 return (
//                                     <MenuItem
//                                         key={provincia.id}
//                                         value={provincia.id}
//                                     // disabled={isDisabled}
//                                     >
//                                         {provincia.cod_ddjj} - {provincia.provincia}{" "}
//                                         {provincia.iibb_auto === 1
//                                             ? "(Padrón)"
//                                             : ""}
//                                     </MenuItem>
//                                 );
//                             })}
//                         </Select>
//                     </FormControl>
//                 )}
//             </Grid>
//             {configConvenio?.evalua_coeficiente_cm05 == 1 && (
//                 <Grid item xs={columnSizes.coeficienteUnificado}>
//                     <InputMask
//                         mask="9.9999"
//                         value={field.coeficiente_unificado}
//                         maskChar="0"
//                         // onChange={(e) => handleInputChange(index, e)}
//                         onChange={(e) => handleInputChange(rowKey, e)}
//                     >
//                         {() => (
//                             <TextField
//                                 variant="filled"
//                                 size="small"
//                                 fullWidth
//                                 name="coeficiente_unificado"
//                                 InputProps={inputProps}
//                                 sx={inputsx}
//                             />
//                         )}
//                     </InputMask>
//                 </Grid>

//             )}
//             <Grid item xs={columnSizes.percepcion}>
//                 <InputMask
//                     disabled={Boolean(field.iibb_auto) || Boolean(field.percepcion_fija)}
//                     mask="9.99"
//                     value={field.percepcion}
//                     maskChar="0"
//                     // onChange={(e) => handleInputChange(index, e)}
//                     onChange={(e) => handleInputChange(rowKey, e)}
//                 >
//                     {() => (
//                         <TextField
//                             disabled={Boolean(field.iibb_auto) || Boolean(field.percepcion_fija)}
//                             variant="filled"
//                             size="small"
//                             fullWidth
//                             name="percepcion"
//                             InputProps={inputProps}
//                             sx={inputsx}
//                         />
//                     )}
//                 </InputMask>
//             </Grid>
//             <Grid item xs={columnSizes.exencion}>
//                 <TextField
//                     // disabled={ !field.percepcion || !field.id_provincia}
//                     value={field.porcentaje_excencion}
//                     // onChange={(e) => handleInputChange(index, e)}
//                     onChange={(e) => handleInputChange(rowKey, e)}
//                     variant="filled"
//                     size="small"
//                     fullWidth
//                     name="porcentaje_excencion"
//                     style={{
//                         backgroundColor:
//                             field.porcentaje_excencion > 100 ||
//                                 field.porcentaje_excencion === "0" ||
//                                 field.porcentaje_excencion === "00" ||
//                                 field.porcentaje_excencion === "000"
//                                 ? "#fadbd8"
//                                 : "#fff",
//                         borderTopLeftRadius: 4,
//                         borderTopRightRadius: 4,
//                     }}
//                     InputProps={{
//                         ...inputProps,
//                         startAdornment: (
//                             <InputAdornment
//                                 sx={{
//                                     display: "flex",
//                                     alignItems: "center",
//                                     marginTop: "auto",
//                                     marginBottom: "auto",
//                                     marginRight: 1,
//                                 }}
//                             >
//                                 <Typography
//                                     variant="subtitle1"
//                                     color={
//                                         field.porcentaje_excencion > 100 ||
//                                             field.porcentaje_excencion === "0" ||
//                                             field.porcentaje_excencion === "00" ||
//                                             field.porcentaje_excencion === "000"
//                                             ? "error"
//                                             : "primary"
//                                     }
//                                 >
//                                     %
//                                 </Typography>
//                             </InputAdornment>
//                         ),
//                     }}
//                     sx={inputsx}
//                 />
//             </Grid>
//             <Grid item xs={columnSizes.vtoExencion}>
//                 <TextField
//                     // disabled={!field.percepcion || !field.id_provincia}
//                     variant="filled"
//                     size="small"
//                     fullWidth
//                     label=""
//                     type="date"
//                     name="vto_excencion"
//                     value={field.vto_excencion}
//                     // onChange={(e) => handleInputChange(index, e)}
//                     onChange={(e) => handleInputChange(rowKey, e)}
//                     InputProps={inputProps}
//                     sx={inputsx}
//                 />
//             </Grid>
//             <Grid
//                 item
//                 xs={columnSizes.acciones}
//                 sx={{
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "space-between",
//                     pr: 3,
//                 }}
//             >
//                 <Tooltip title="Eliminar IIBB">
//                     <IconButton
//                         onClick={() => deshacerAlmacenar(field)}
//                         color="error"
//                         sx={{ p: 0.5 }}
//                     >
//                         <DeleteIcon />
//                     </IconButton>
//                 </Tooltip>
//                 {index === inscrIIBB.length - 1 && (
//                     <Tooltip title="Agregar IIBB">
//                         <IconButton
//                             disabled={configConvenio?.max_inscripciones && inscrIIBB.length >= configConvenio.max_inscripciones}
//                             onClick={() => almacenarImpuesto()}
//                             color="success"
//                             sx={{ p: 0.5 }}
//                         >
//                             <AddCircleOutlineIcon />
//                         </IconButton>
//                     </Tooltip>
//                 )}
//             </Grid>
//         </Grid>
//     </>
// )


*/ 